module.exports = __webpack_public_path__ + "img/img02.e34e7a6c.png";